<template>
  <div class="uk-width-1-3@s">
    <div class="uk-card uk-text-center">
      <div class="uk-card-header uk-margin-small-bottom">
        <img :src="icon" :alt="title" class="uk-width-1-6 uk-margin-small-bottom" />
        <h3 class="uk-margin-small-top">{{title}}</h3>
        <hr class="uk-hr uk-divider-small"/>
      </div>
      <div class="uk-card-body uk-padding-remove-top usp-card">
        <p>
          <slot></slot>
        </p>
      </div>
<!--      <div class="uk-card-footer uk-visible@m">-->
<!--        <router-link-->
<!--          :to="link"-->
<!--          class="uk-button uk-button-secondary uk-width-auto uk-position-bottom-center"-->
<!--          v-if="hasLink"-->
<!--        >-->
<!--          Meer informatie-->
<!--        </router-link>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'USPCard.vue',
  props: {
    title: String,
    link: {
      required: false,
    },
    icon: {
      type: String,
    },
  },
  computed: {
    hasLink() { return this.link.length > 0; },
  },
});
</script>

<style lang="scss">
  .usp-card p {
    color: rgba(247, 247, 247, 0.9);
    font-size: 13px;
  }
  .usp-card h3 {
    font-size: 15px;
    font-weight: bold;
  }
</style>
